import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { AlphabetItem } from '@app/hooks/useGroupedMakers';
import styles from '@styles/Maker/filter.module.scss';
import { Anchor, Button, Dropdown, Grid, Input } from 'antd';
import cn from 'classnames';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useScrollHandler } from 'services';

interface AnchorElProps {
  className?: string;
  alphabet: AlphabetItem[];
}

const AnchorEl: FC<AnchorElProps> = ({ className, alphabet }) => {
  const { Link } = Anchor;

  return (
    <Anchor affix={false} className={className} offsetTop={144}>
      {alphabet.map((item) => {
        if (item.enabled) {
          return (
            <Link
              key={item.char}
              href={`#maker-${item.char.toLocaleUpperCase()}`}
              title={item.char}
              className={styles.anchorLink}
            />
          );
        }

        return (
          <span key={item.char} className={`${styles.anchorLink} ${styles.anchorLinkDisabled}`}>
            {item.char}
          </span>
        );
      })}
    </Anchor>
  );
};

type Props = {
  setNameQuery: (value: string) => void;
  alphabet: AlphabetItem[];
};

const MakerFilter: FC<Props> = ({ setNameQuery, alphabet }) => {
  const { xl } = Grid.useBreakpoint();

  const { formatMessage } = useIntl();
  const f = (id: string): string => formatMessage({ id });

  const { Link } = Anchor;
  const { stickyHeader } = useScrollHandler();

  return (
    <div className={cn(styles.container, { [styles.isSticky]: stickyHeader })}>
      {!xl ? (
        <div className={styles.containerDropdown}>
          <h3 className={styles.dropdownTitle}>Filter by letter</h3>

          <Dropdown
            overlay={<AnchorEl className={styles.dropdownAnchor} alphabet={alphabet} />}
            trigger={['click']}
            overlayClassName={styles.dropdown}
            getPopupContainer={(trigger: any) => trigger.parentNode}
          >
            <Button className={styles.dropdownButton}>
              Select letter... <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      ) : (
        <Anchor affix={false} className={styles.containerAnchor} offsetTop={144}>
          {alphabet.map((itemGroup) => {
            if (itemGroup.enabled) {
              return (
                <Link
                  key={itemGroup.char}
                  href={`#maker-${itemGroup.char.toLocaleUpperCase()}`}
                  title={itemGroup.char}
                  className={styles.anchorLink}
                />
              );
            }

            return (
              <span key={itemGroup.char} className={`${styles.anchorLink} ${styles.anchorLinkDisabled}`}>
                {itemGroup.char}
              </span>
            );
          })}
        </Anchor>
      )}

      <div className={styles.containerSearch}>
        <Input
          placeholder={f('maker.filter.search.placeholder')}
          suffix={<SearchOutlined />}
          onChange={(e) => setNameQuery(e.target.value)}
          className={styles.search}
          allowClear
        />
      </div>
    </div>
  );
};

export default MakerFilter;
